import { ProfileSettings } from "./ProfileSettings";
import { EmailNotificationSettings } from "./EmailNotificationSettings";

export const AccountSettings = () => {
  return (
    <div className="space-y-6">
      <ProfileSettings />
      <EmailNotificationSettings />
    </div>
  );
};
